import { Box, Button, Grid, Typography, TextField, Modal, Tooltip, Breadcrumbs, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HttpRequest } from "../HttpRequest";
import { ArrowBackIos, Circle, EditOutlined } from "@mui/icons-material";
import CustomInputLabel from "../common/CustomInputLabel";
import { SuccessAlert } from "../common/snackbar/success";
import { ErrorAlert } from "../common/snackbar/error";
import CustomTable from "../common/CustomTable";
import CustomSearchInput from "../common/CustomSearchInput";
import warningIcon from '../../images/warning-remove-icn.svg';
import DeleteIcon from '@mui/icons-material/Delete';
import { DataGrid } from "@mui/x-data-grid";
import ReusableModal from "../common/ReusableModal";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";


const deleteShippingRegionModal = {
  borderRadius: "10px", backgroundColor: "#fff", position: 'absolute', top: '40%', left: '50%', transform: 'translate(-50%, -50%)', width: "400px", height: "130px", p: '61px 22px 165px 63px', border: '1px #707070', m: '55px 104px 6.5px 118px'
}
const ShippingRegion = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [search, setSearch] = useState('');
  const [successShow, setSuccessShow] = useState({ state: false, message: "" })
  const [errorShow, setErrorShow] = useState({ state: false, message: "" })
  const [showModalAddRegion, setshowModalAddRegion] = useState(false)
  const [showModalEditRegion, setShowModalEditRegion] = useState(false)
  const [shippingRegion, setShippingRegion] = useState({})
  const [dataGridPageSize, setPageSize] = useState(10);
  const [pageState, setPageState] = useState({ isLoading: false, data: [], total: 0, page: 1, pageSize: dataGridPageSize, })
  const [shippingRegionData, setShippingRegionData] = useState({
    regionName: "",
    regionDescription: "",
    shippingCost: "",
  })
  const [openDeleteShippingRegion, setOpenDeleteShippingRegion] = useState(false)
  const handleOpenDeleteShippingRegion = () => { setOpenDeleteShippingRegion(true) }
  const handleCloseDeleteShippingRegion = () => { setOpenDeleteShippingRegion(false) }

  const handleFormData = (e) => {
    const { name, value } = e.target
    setShippingRegionData({ ...shippingRegionData, [name]: value })
  }
  const handleRowClick = (event, params) => {
    event.stopPropagation();
    setShippingRegionData({
      regionName: params?.row?.regionName,
      regionDescription: params?.row?.regionDescription,
      shippingCost: params?.row?.shippingCost,
    })
    setShippingRegion(params?.row);
    setShowModalEditRegion(true);
  }
  const columns = [
    {
      field: 'regionName', headerName: 'Region Name', flex: isMobile ? 1 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Region Name </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>
          <Grid container spacing={2}>
            <Grid item>
              {params?.row?.regionName}
            </Grid>
          </Grid>
        </Box>)
      }
    },
    {
      field: 'regionDescription', headerName: 'Description', flex: isMobile ? 1.5 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Description   </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>
          {params?.row?.regionDescription}
        </Box>)
      }
    },
    {
      field: 'shippingCost', headerName: 'Shipping Cost', flex: isMobile ? 1 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Shipping Cost   </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>
          {params?.row?.shippingCost}
        </Box>)
      }
    },
    {
      field: 'action', headerName: 'Action', flex: isMobile ? 0.8 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Action  </Box>) },
      renderCell: (params) => {
        const onClickDelete = (event) => {
          event.stopPropagation();
          setShippingRegion(params?.row);
          handleOpenDeleteShippingRegion(true);
        }
        return (
          <Box style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "13px" : "25px", fontWeight: "500", marginTop: isMobile ? '5px' : '0' }}>
            <Tooltip title="Edit">
            <EditOutlined onClick={(event)=>handleRowClick(event,params)} sx={{ color: '#032541', marginRight: '10px', fontSize: isMobile ? '18px' : 'inherit' }} />
            </Tooltip>
            <Tooltip title="Delete">
            <DeleteIcon onClick={onClickDelete} sx={{ color: '#DC3545', fontSize: isMobile ? '18px' : 'inherit' }} />
            </Tooltip>
          </Box>
        )
      }
    },
  ]

  const getShippingRegion = () => {
    setPageState((old) => ({ ...old, isLoading: true }));
    HttpRequest({
      method: 'GET',
      url: `/api/v1/ecommerce/get_shipping_regions?searchValue=${search}`
    }).then((data) => {
      setPageState({
        ...pageState,
        data: data?.response?.data,
        total: data?.response?.count || data?.response?.data?.length,
        isLoading: false
      })
    }).catch((error) => {
    });
  }

  const navigate = useNavigate();

  const handleRegionSubmit = () => {
    if (!shippingRegionData.regionName) {
      setErrorShow({ state: true, message: "Location name is required" });
      return;
    }
    if (!shippingRegionData.regionDescription) {
      setErrorShow({ state: true, message: "Location description is required" });
      return;
    }
    if (!shippingRegionData.shippingCost) {
      setErrorShow({ state: true, message: "Location description is required" });
      return;
    }
    HttpRequest({
      method: 'POST',
      url: `/api/v1/ecommerce/add_shipping_regions`,
      body: shippingRegionData

    }).then((data) => {
      if (data?.status === 200) {
        setSuccessShow({ state: true, message: "Shipping Region added successfully" });
        setshowModalAddRegion(false)
        getShippingRegion()
        setShippingRegionData({
          regionName: "",
          regionDescription: "",
          shippingCost: "",
        })
      } else {
        setErrorShow({ state: true, message: data.response?.data?.message });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: "Error adding shipping Region" });
    })
  }
  const handleRegionUpdateSubmit = () => {
    if (!shippingRegionData.regionName) {
      setErrorShow({ state: true, message: "Location name is required" });
      return;
    }
    if (!shippingRegionData.regionDescription) {
      setErrorShow({ state: true, message: "Location description is required" });
      return;
    }
    if (!shippingRegionData.shippingCost) {
      setErrorShow({ state: true, message: "Location description is required" });
      return;
    }
    HttpRequest({
      method: 'POST',
      url: `/api/v1/ecommerce/edit_shipping_regions/${shippingRegion._id}`,
      body: shippingRegionData

    }).then((data) => {
      if (data?.status === 200) {
        setSuccessShow({ state: true, message: "Shipping Region updated successfully" });
        setShowModalEditRegion(false)
        getShippingRegion()
        setShippingRegionData({
          regionName: "",
          regionDescription: "",
          shippingCost: "",
        })
      } else {
        setErrorShow({ state: true, message: data.response?.data?.message });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: "Error updating shipping Region" });
    })
  }
  const handleDeleteShippingRegion = (id) => {
    handleCloseDeleteShippingRegion();
    HttpRequest({
      method: 'DELETE',
      url: `/api/v1/ecommerce/delete_shipping_regions/${id}`,
    }).then((data) => {
      if (data?.status === 200) {
        setSuccessShow({ state: true, message: "Shipping deleted successfully" });
        setShippingRegion({});
        setShippingRegionData({
          regionName: "",
          regionDescription: "",
          shippingCost: "",
        })
        getShippingRegion()
      } else {
        setErrorShow({ state: true, message: data.response?.data?.message });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: "Error deleting shipping region" });
    })
  }
  useEffect(() => {
    getShippingRegion()
  }, [search])

  const breadcrumbs = [
      <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem", ml: isMobile ? 0 : 3 }}>
          Dashboard
      </Typography>,
      <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem" }}>
          Delivery Methods
      </Typography>,
      <Typography key={"add"} sx={{ color: "#dc3545", fontSize: "0.875rem" }}>
          Shipping Regions
      </Typography>
    ];
  return (
    <Box sx={{ mt: { xs: "15%", sm: "4%" }, pr: { xs: 2, sm: "3.5%" }, width: { xs: "100vw", sm: "calc(100vw - 355px)" }, maxWidth: "100%", overflowX: "hidden", boxSizing: "border-box", px: { xs: 2, sm: 0 }, ml: { xs: -3, sm: 0 } }}>      
      <SuccessAlert vertical="top" horizontal="right" onClose={() => setSuccessShow({ ...successShow, state: false })} open={successShow.state} message={successShow.message} />
      <ErrorAlert vertical="top" horizontal="right" onClose={() => setErrorShow({ ...errorShow, state: false })} open={errorShow.state} message={errorShow.message} />
      
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: { xs: "flex-start", sm: "center" }, flexDirection: { xs: "column", sm: "row" }, gap: { xs: 2, sm: 0 } }}>
        <Box sx={{ flexDirection: "column", flex: 1 }}>
          <Box mb={1.5}>
            {showModalAddRegion ? (
              <Box variant="h4" sx={{ display: 'flex', alignItems: 'center' }}>
                <ArrowBackIos sx={{ width: '25px', height: '35px', objectFit: 'contain'}} onClick={() => { setshowModalAddRegion(false) }} />
                <Typography sx={{ color: "#032541", fontSize: { xs: "18px", sm: "28px" }, fontStyle: "normal", fontWeight: "600" }}>
                  Add Shipping Region
                </Typography>
              </Box>
            ) : showModalEditRegion ? (
              <Box variant="h4" sx={{ display: 'flex', alignItems: 'center' }}>
                <ArrowBackIos sx={{ width: '25px', height: '35px', objectFit: 'contain'}} onClick={() => { setShowModalEditRegion(false) }} />
                <Typography sx={{ color: "#032541", fontSize: { xs: "18px", sm: "28px" }, fontStyle: "normal", fontWeight: "600" }}>
                  Edit Shipping Region
                </Typography>
              </Box>
            ) : (
              <Typography variant="h4" sx={{ color: "#032541", fontSize: { xs: "18px", sm: "28px" }, fontStyle: "normal", fontWeight: "600" }}>
                Shipping Regions
              </Typography>
            )}
          </Box>
          <Grid item sx={{ mt: 1, mb: { xs: 1, sm: 1 }, ml: { sm: -3 } }}>
            <Breadcrumbs style={{ fontFamily: 'Poppins', fontSize: { xs: "11px", sm: "13px" } }} separator={<FiberManualRecordIcon style={{ fontSize: "0.625rem", fontFamily: 'Poppins', color: "#e1e5e8" }} />} aria-label="breadcrumb">
                {breadcrumbs}
            </Breadcrumbs>
          </Grid>
          <Box>
            <Typography variant="h4" sx={{ color: "#707070", fontSize: { xs: "12px", sm: "14px" }, fontStyle: "normal", fontWeight: "normal" }}   >
              View and manage your Shipping Regions
            </Typography>
          </Box>
        </Box>
        {showModalAddRegion || showModalEditRegion ? null :
          <Box sx={{ width: { xs: '100%', sm: 'auto' }, mt: { xs: 2, sm: 0 } }}>
            <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#032541", color: "#fff" }, width: { xs: '100%', sm: 'auto' }}} onClick={() => setshowModalAddRegion(true)}>
              Add Region
            </Button>
          </Box>
        }
      </Box>
      
      {showModalAddRegion || showModalEditRegion ? null :
        <Box sx={{ display: 'flex', mt: 2 }}>
          <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
            <CustomSearchInput placeholder={"Search region name ...."} name="search" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: '100%', sm: 'auto' } }} />
          </Box>
        </Box>
      }
      
      {showModalAddRegion ?
        <>
          <Box sx={{ width: { xs: "100%", sm: "500px" }, mt: 2 }}>
            <Box sx={{ width: "100%", marginTop: "20px" }}>
              <CustomInputLabel label="Region  Name" placeholder="Enter Location Name " />
              <TextField label="Region Name" value={shippingRegionData?.regionName} name="regionName" onChange={handleFormData} placeholder="Nairobi - Region" sx={{ width: "100%" }} size={isMobile ? "small" : "medium"}/>
            </Box>
            <Box sx={{ width: "100%", marginTop: "20px" }}>
              <CustomInputLabel label="shipping Amount" placeholder="Enter  cost*" />
              <TextField label="shipping Cost Amount" type="number" value={shippingRegionData?.shippingCost} name="shippingCost" onChange={handleFormData} placeholder="Nairobi - CBD" sx={{ width: "100%" }} size={isMobile ? "small" : "medium"}/>
            </Box>
            <Box sx={{ width: "100%", marginTop: "20px" }}>
              <CustomInputLabel label="Description" placeholder="Enter  Description*" />
              <TextField name={"regionDescription"} value={shippingRegionData.regionDescription} onChange={handleFormData} placeholder={"Description"} variant="outlined" margin="dense" sx={{ marginBottom: 2, width: "100%" }} multiline minRows={2} size={isMobile ? "small" : "medium"}/>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", alignContent: "end", gap: 1, flexDirection: { xs: "column", sm: "row" } }}>
              <Button variant="contained" sx={{ backgroundColor: "#fff", color: "#dc3545", textTransform: "none", borderRadius: "5px", border: "1px solid #dc3545", padding: "10.4px 30px 9.6px 30px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#fff", color: "#dc3545" }, width: { xs: '100%', sm: 'auto' }}} onClick={() => setshowModalAddRegion(false)}>
                Cancel
              </Button>
              <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#032541", color: "#fff" }, width: { xs: '100%', sm: 'auto' }}} onClick={handleRegionSubmit}>
                Add Region
              </Button>
            </Box>
          </Box>
        </>
        : showModalEditRegion ?
          <>
            <Box sx={{ width: { xs: "100%", sm: "500px" }, mt: 2 }}>
              <Box sx={{ width: "100%", marginTop: "20px" }}>
                <CustomInputLabel label="Region  Name" placeholder="Enter Location Name " />
                <TextField label="Region Name" value={shippingRegionData?.regionName} name="regionName" onChange={handleFormData} placeholder="Nairobi - Region" sx={{ width: "100%" }} size={isMobile ? "small" : "medium"}/>
              </Box>
              <Box sx={{ width: "100%", marginTop: "20px" }}>
                <CustomInputLabel label="shipping Amount" placeholder="Enter  cost*" />
                <TextField label="shipping Cost Amount" type="number" value={shippingRegionData?.shippingCost} name="shippingCost" onChange={handleFormData} placeholder="Nairobi - CBD" sx={{ width: "100%" }} size={isMobile ? "small" : "medium"}/>
              </Box>
              <Box sx={{ width: "100%", marginTop: "20px" }}>
                <CustomInputLabel label="Description" placeholder="Enter  Description*" />
                <TextField name={"regionDescription"} value={shippingRegionData.regionDescription} onChange={handleFormData} placeholder={"Description"} variant="outlined" margin="dense" sx={{ marginBottom: 2, width: "100%" }} multiline minRows={2} size={isMobile ? "small" : "medium"}/>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-end", alignContent: "end", gap: 1, flexDirection: { xs: "column", sm: "row" } }}>
                <Button variant="contained" sx={{ backgroundColor: "#fff", color: "#dc3545", textTransform: "none", borderRadius: "5px", border: "1px solid #dc3545", padding: "10.4px 30px 9.6px 30px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#fff", color: "#dc3545" }, width: { xs: '100%', sm: 'auto' }}} onClick={() => setShowModalEditRegion(false)}>
                  Cancel
                </Button>
                <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#032541", color: "#fff" }, width: { xs: '100%', sm: 'auto' }}} onClick={handleRegionUpdateSubmit}>
                  Update
                </Button>
              </Box>
            </Box>
          </> :
          <Box sx={{ width: '100%', overflowX: 'auto', mt: 2 }}>
            <Box sx={{ minWidth: { xs: 800, sm: '100%' } }}>
            <DataGrid
                sx={{ minHeight: '500px', height: 'auto', width: 'auto', fontFamily: 'Poppins', fontSize: isMobile ? '10px' : '12px', color: '#272d3d', boxShadow: 0, border: 0, '& .MuiDataGrid-cell': { fontSize: isMobile ? '10px' : '12px',}}}
              rowCount={pageState.total}
              pagination
              loading={pageState.isLoading}
              page={pageState.page - 1}
              pageSizeOptions={[1, 10, 20, 50, 100]}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: dataGridPageSize,
                    page: pageState.page - 1,
                  },
                },
              }}
              pageSize={dataGridPageSize}
              onPaginationModelChange={(data) => {
                const { pageSize, page } = data;
                setPageState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
                setPageSize(pageSize)
              }}
              paginationMode="server"
              columns={columns}
              rows={pageState.data}
              getRowId={(row) => row._id}
            />
            </Box>
          </Box>
      }
      
    <ReusableModal open={openDeleteShippingRegion} onClose={handleCloseDeleteShippingRegion}>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", pt: 4, px: 3,}}>
        <Box sx={{ mb: 2 }}>
          <img src={warningIcon} alt="warning" width={70} height={70} style={{ objectFit: "contain" }}/>
        </Box>
        <Typography sx={{ color: "#032541", fontFamily: "Poppins", fontWeight: 600, fontSize: { xs: "16px", sm: "18px" }, mb: 1.5, textAlign: "center",}}>
          Delete Shipping Region?
        </Typography>
        <Typography sx={{ color: "#707070", fontFamily: "Poppins", fontSize: { xs: "12px", sm: "14px" }, mb: 2, textAlign: "center",}}>
          Selected shipping region will be deleted. This action cannot be undone.
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 3,}}>
          <Circle sx={{ width: "10px", height: "10px", color: "#0c253f", mr: 1 }} />
          <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "14px", sm: "16px" }, color: "#032541", textAlign: "center",}}>
            {shippingRegion?.regionName}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <Button sx={{ height: "45px", width: "125px", borderRadius: "4px", backgroundColor: "#dc3545", color: "#fff", fontWeight: 600, fontSize: "14px", fontFamily: "Poppins", textTransform: "none", "&:hover": { backgroundColor: "#c82333" }}} onClick={() => handleDeleteShippingRegion(shippingRegion._id)}>
            Delete
          </Button>
        </Box>
      </Box>
    </ReusableModal>
    </Box>
  )
}

export default ShippingRegion